export const fonts = {
  body: `'adineuePRO', sans-serif`,
  heading: `'adineuePRO', sans-serif`,
};
